<template>
	<div class="dropItem">
		<ul>
			<li v-for="(item, index) in items" @click="item_change(index, item)">
				<span class="select" v-if="item.select">√</span>
				<span class="select" v-else> </span>
				<span class="title">{{item.title}}</span>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'dropItem',
		data(){
			return {}
		},
		props: {
			items: {
				type: Array,
				default: function(){
					return [];
				},
			}
		},
		methods: {
			item_change(index, item){
				// 相同分组其他元素取消选项
				_.each(this.items, (v, k)=>{
					if(v.group === item.group && v.key !== item.key){
						v.select = false;
					}
				});

				// 若该选项是非空
				// if(!item.single){
				this.items[index].select = !this.items[index].select;
				// }
				this.$emit('submit_key', item);
			}
		}
	}
</script>

<style scoped lang="less">
	@back-color: #595959;
	@hover-color: #252526;
	.dropItem {
		position: relative;
		background: @back-color;
		color: white;
		width: 150px;
		z-index: 99;
		border: 1px solid @back-color;
		border-radius: 3px 3px;
		
		ul {
			list-style: none;
			
			li {
				text-align: left;
				padding: 4px 0;
				padding-left: 5px;
				border-bottom: 1px solid @hover-color;
			}
			
			li:last-child {
				border-bottom: none;
			}
			
			li:hover {
				background: @hover-color;
			}
			
			.select {
				display: inline-block;
				width: 26px;
				padding: 0 10px;
			}
		}
	}
</style>
